import React, { useState } from 'react';
import A1 from '../Images/logo-w.png';
import { FiMail, FiLock } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; 

const AdminLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate(); 

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.get('https://erpapi.emedha.in/auth/api/api/admin');
            const adminData = response.data;
            const matchedAdmin = adminData.find(
                (admin) => admin.email === email && admin.password === password
            );
            if (matchedAdmin) {
                navigate('/admindashboard-admindashboard');
            } else {
                alert('Invalid email or password');
            }
        } catch (err) {
            console.error('Error fetching admin data:', err);
            alert('An error occurred, please try again later');
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f4f4f4' }}>
            <div style={{ backgroundColor: '#dbc4a9', padding: '30px', borderRadius: '8px', height: '450px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', width: '500px', textAlign: 'center' }}>
                <img src={A1} alt="Logo" style={{ width: '60%' }} />
                <h2 className="mt-2" style={{ marginBottom: '20px', fontSize: '24px', color: '#333' }}>Admin Login</h2>
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '15px', textAlign: 'left', position: 'relative' }}>
                        <label htmlFor="email" style={{ fontSize: '14px', color: '#666' }}>Email</label>
                        <div style={{ position: 'relative' }}>
                            <FiMail style={{ position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)', color: '#666' }} />
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                                style={{ width: '100%', padding: '10px 10px 10px 30px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', color: '#333', boxSizing: 'border-box' }}
                            />
                        </div>
                    </div>
                    <div style={{ marginBottom: '15px', textAlign: 'left', position: 'relative' }}>
                        <label htmlFor="password" style={{ fontSize: '14px', color: '#666' }}>Password</label>
                        <div style={{ position: 'relative' }}>
                            <FiLock style={{ position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)', color: '#666' }} />
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                                required
                                style={{ width: '100%', padding: '10px 10px 10px 30px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', color: '#333', boxSizing: 'border-box' }}
                            />
                        </div>
                    </div>
                    <button
                        className="mt-4"
                        type="submit"
                        style={{ width: '100%', padding: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', fontSize: '16px', cursor: 'pointer' }}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = '#007bff')}
                    >
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
